import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';

const DASHBOARD_API_ROUTES = {
  GET_DASHBOARD_DATA: 'admin/dashboard',
};
@Injectable({
  providedIn: 'root'
})
export class DashboardHttpService {
  constructor(private httpClient: HttpClient,
              private generalHttpHelperService: GeneralHttpHelperService) { }

  private getDashboardDataReq(urlParams?: Record<string, any>): Observable<any> {
    return this.httpClient.get(DASHBOARD_API_ROUTES.GET_DASHBOARD_DATA) as any;
  }

  getDashboardData(urlParams?: Record<string, any>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getDashboardDataReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
